import React from "react";
import { Link } from "react-router-dom";
import "./ServiceList.css";

const services = [
  {
    titleTop: "Family-Centered",
    titleAccent: "Program",
    titleBottom: "Design",
    desc: "Development or refinement of programs, with emphasis on cultural responsiveness, accessibility, and real-world impact.",
  },
  {
    titleTop: "Father",
    titleAccent: "Engagement",
    titleBottom: "Strategy",
    desc: "Assessment, planning, and implementation support to strengthen father involvement and remove barriers.",
  },
  {
    titleTop: "Community Outreach",
    titleAccent: "& Partnership",
    titleBottom: "Development",
    desc: "Strategy and facilitation to expand organizational reach and build authentic community relationships.",
  },
  {
    titleTop: "Training &",
    titleAccent: "Curriculum",
    titleBottom: "Development",
    desc: "Delivery of trainings on father engagement, trauma-informed practice, community-building, systems navigation, and related topics.",
  },
  {
    titleTop: "Behavioral Health",
    titleAccent: "System",
    titleBottom: "Navigation",
    desc: "Guidance for organizations working with families in or impacted by behavioral health systems.",
  },
  {
    titleTop: "Organizational",
    titleAccent: "Capacity",
    titleBottom: "Building",
    desc: "Strategic planning, operational improvement, and systems development for nonprofits and agencies.",
  },
];

const ServiceList = () => {
  return (
    <section className="cis-serviceList" id="services" aria-label="Our services">
      <div className="cis-serviceList__container">
        {/* Header with underline */}
        <div className="cis-serviceList__header">
          <h2 className="cis-serviceList__title">
            Our <span>Services</span>
          </h2>
          <div className="cis-serviceList__underline"></div>
        </div>

        {/* Cards - Images and buttons removed */}
        <div className="cis-serviceList__grid">
          {services.map((s, idx) => (
            <article className="cis-serviceList__card" key={idx}>
              <div className="cis-serviceList__content">
                <h3 className="cis-serviceList__cardTitle">
                  {s.titleTop} <span>{s.titleAccent}</span>
                  <br />
                  {s.titleBottom}
                </h3>

                <p className="cis-serviceList__desc">{s.desc}</p>
              </div>
            </article>
          ))}
        </div>

        {/* Contact Us button below the section */}
        <div className="cis-serviceList__buttonWrap">
          <Link to="/contact" className="cis-serviceList__contactButton">
            Contact Us
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServiceList;